module.exports = __webpack_public_path__ + "media/common/interview-examples1-1eeacc4e.svg";